<template>
  <div class="scroll">
    <b-container>
      <b-row>
        <b-col v-on:drop="ondrop($event, null, true)" cols="6">
          <label>Visade:</label>
          <b-card style="min-height: 900px" v-on:drop="ondrop($event, c, true)">
            <div v-for="c in GetColumns(true)" :key="c.id" :id="'col' + c.id" draggable="true"
              v-on:drop="ondrop($event, c, true)" v-on:dragstart="ondrag" v-on:dragover="ondragover">
              <b-card class="columnbox" id="popover-helptext-qvm-1">
                <b-row>
                  <b-col :title="getHelpText(c)" @mouseover="OnColHover(c)" cols="11">{{ c.Name }}</b-col>
                  <b-col>
                    <b-icon-x-circle v-on:click="setVisible(c, false)" :title="'Dölj kolumn'"></b-icon-x-circle>
                  </b-col>
                </b-row>
              </b-card>
            </div>
          </b-card>
        </b-col>
        <b-col v-on:drop="ondrop($event, null, false)" cols="6">
          <label>Dolda:</label>
          <b-card style="min-height: 900px">
            <div v-for="c in GetSortedColumns(false)" :key="c.id" :id="'col' + c.id" draggable="true"
              v-on:dragstart="ondrag" v-on:drop="ondrop($event, c, false)" v-on:dragover="ondragover">
              <b-card class="columnbox">
                <b-row>
                  <b-col :title="getHelpText(c)" @mouseover="OnColHover(c)" cols="11" v-on:click="setVisible(c, true)">
                  {{c.Name}}
                  </b-col>
                  <b-col>
                    <b-icon-plus-circle v-on:click="setVisible(c, true)"
                      :title="'Visa kolumn'"></b-icon-plus-circle>
                  </b-col>
                </b-row>
              </b-card>
            </div>

          </b-card>
        </b-col>
      </b-row>
      <!-- <b-popover v-if="helpDescr" :show.sync="showHelp" target="popover-helptext-qvm-2" triggers="manual"
        placement="top">
        <template #title></template>
        {{ helpDescr.description }}
      </b-popover> -->
    </b-container>
  </div>
</template>
<script>
import { Api } from "../../lib/api";
const api = new Api();

export default {
  name: "QueryViewManager",
  props: { columns: Array },
  watch: {
    columns() {
      var cols = this.GetColumns(true);
      for (var i = 0; i < cols.length; i++) {
        if (cols[i].ColOrder !== i)
          cols[i].ColOrder = i;
      }
    }
  },
  data() {
    return {
      columns: null,
      helpDescr: null,
      helpDescrRepository: [],
      showHelp: false,
      hover:null
    };
  },
  methods: {
    GetColumns(onlyVisible) {
      if (!this.columns) return;
      var res = this.columns.filter((x) => x.Visible == onlyVisible);
      return res.sort((a, b) => a.ColOrder - b.ColOrder);
    },
    GetSortedColumns(onlyVisible) {
      var res = this.GetColumns(false);
      res.sort((a, b) => a.Name.toUpperCase() < b.Name.toUpperCase() ? -1 : 1)

      return res;
    },
    ondrop(ev, c, visible) {
      //alert("Dropped");
      ev.preventDefault();
      var data = ev.dataTransfer.getData("text");
      var dro = JSON.parse(data);

      if (dro.type != "column") {
        alert("Det går endast att flytta kolumner hit.");
        return;
      }
      var this_id = dro.id;
      var col = this.columns.find((x) => "col" + x.id == this_id);
      if (!col) return;
      col.Visible = visible;
      if (c) {
        var destColOrder = c.ColOrder;
        if (visible) {
          //Change ColOrder
          this.columns.map((x) => {
            if (x.ColOrder >= destColOrder) x.ColOrder++;
          });
          col.ColOrder = destColOrder;
        }
      }
    },
    ondragover(ev) {
      ev.preventDefault();
      console.log("Ondragover");
    },
    ondrag(ev) {
      var dro = { type: "column", id: ev.target.id };
      ev.dataTransfer.setData("text", JSON.stringify(dro));
    },
    setVisible(c, visible) {
      c.Visible = visible;
    },
    OnColHover(c) {
      this.showHelp = true;
      this.hover = c;
      this.helpDescr = null;
      if (c) this.helpDescr = this.GetHelpDescr(c.ColName);
    },
    GetHelpDescr(keyName) {
      let k = keyName.toUpperCase();
      if (!this.helpDescrRepository[k]) {
        api.get("/api/apiqueryview/GetHelpDescription?keyName=" + k)
          .then(res => {
            this.helpDescr = res.data;
            this.helpDescrRepository[k] = res.data;
          }
          );
      }
      return this.helpDescrRepository[k];
    },
    OnColUnHover(c) {
      this.helpDscr = null;
      this.hover = null;
    },
    getHelpText(c) {
      if(this.helpDescr && c == this.hover)
        return this.helpDescr.description;
    }
  },
};
</script>
<style scoped>
.scroll {
  max-height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
}

.columnbox :hover {
  background-color: lightgrey;
}
</style>